import React, { Component } from 'react';
import { connect } from 'react-redux';

class AccountSettings extends Component {
	render() {
		return (
			<div className="accounts-container mx-auto">
				<div className="py-4 py-xl-5">
					<h3 className="h5 mb-0 mt-2">Privacy Manager</h3>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);